import Swiper from 'swiper/bundle';

export default class Sliders {
    constructor() {
        this.init();
    }

    init() {

        // === PRODUCT SWIPER ===
        const productSwiper = new Swiper(".product-swiper", {
            effect: "cards",
            grabCursor: true,
            navigation: {
                nextEl: ".product-swiper .swiper-next",
                prevEl: ".product-swiper .swiper-prev",
            },
        });
        
    }
}